const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "작성년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-select",
        label: "점검종류",
        value: "type",
        query: { type: "select" },
        options: {
          items: ["리스크진단", "기타"],
          default: "",
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "작성일", "점검종류", "점검일", "작성일", "파일첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    const year = search.year;
    if (year) {
      conditions.push({ key: "created_at", operator: "LIKE", value: `${year}-%` });
    }

    // 사업장
    const params = new URLSearchParams(window.location.search);
    const fd = params.get("fd");
    conditions.push({ key: "body.stdInfo.field_name", operator: "=", value: fd });

    // 점검종류
    if (search.type) {
      conditions.push({ key: "body.점검정보.점검종류", operator: "=", value: search.type });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "점검종류",
        key: "body.점검정보.점검종류",
      },
      {
        name: "제목",
        key: "body.점검정보.제목",
      },
      {
        name: "소속1",
        key: "body.stdInfo.section",
      },
      {
        name: "작성일",
        key: "created_at",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "파일첨부",
        key: "body.fileList",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContent(value).점검정보.점검종류; // 점검종류
        case 2:
          return func.getContent(value).점검정보.제목; // 제목
        case 3:
          return func.getContent(value).stdInfo.section; // 부서명
        case 4:
          return func.getCreatedDate(value.created_at); // 작성일
        case 5:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 6: // 파일첨부
          const file = func.getContent(value).fileList;
          return {
            type: "file",
            files: file,
          };
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
